// In order to use our own reels player instead of JW's reels player, we
// need to map existing placement IDs to playlist IDs.
export const placementIdToPlaylistId = {
  N5jv0LX2: 'yWvdKUet', // Allas reels - senaste videos
  qvLW8WSV: 'NSNoQkVx', // Allas reels - starkt innehåll
  uYmQ8fXT: 'aDVu5TgU', // Allas reels – DIY, trädgård & mat
  '77JS0viF': 'uDvTvRMj', // ELLE all reels
  '7Fz8tfy9': 'AR1Y4XVt', // ELLE-galan reels
  '3cSIhLsD': 'fEvQ4c9l', // ELLE julkalendrar
  Bfg8hTUE: 'VL9nI8EQ', // ELLE reels - astrobarometern
  LvBl2KtK: 'b4mvM6lV', // Femina reels senaste
  '339D29Jt': 'kinc8CvU', // Femian reels - mode & skönhet
  DAcLM1ZW: 'Qa2RcWhJ', // Femina - Kändis
  Ee32G9MM: 'F4JVIHyM', // Femina reels - starka berättelser
  AeUbIjHk: '1d1uZdSO', // Femina reels – smalgoritmen
  rPyh8VQP: 'oXz9b96n', // Hänt reels – senast publicerade
  E5hLzIK8: 'gOswM08S', // Hänt reels – Tv-serier & streaming
  bVcJgkrU: 'JsOXnjKZ', // Hänt reels – mest sedda
  Tfc2UQZe: 'bljf8WOS', // Hänt reels – trendar nu
  Qin05GpX: 'QmaBNvk3', // MELODIFESTIVALEN 2026 – alla klipp från årets musikfest!
  '1JWJUY2F': 'sDPJrwBL', // MåBra reels
  '40wxJS2q': 'vdgZoHpW', // Residence reels
  FyvlNd5x: 'T6vMdrHm', // Svensk dam reels - KUNGLIGT
  xyGsI5kx: 'JxzJ0J44', // Svensk Dam reels – NÖJE
  M28mRs2S: '04JmUHUL', // Svensk dam reels - prinsessan Madeleine
  uUohlZc9: 'FsFwEQHN', // Svensk dam reels - prinsessan Sofia
  tXJ8Jh1Y: 'rQlpw2jU', // Svensk dam reels - kungaparet
  '7fXRmlV7': 'unRT35lY', // Svensk dam reels - kronprinsessan Victoria
  sY7y3MBL: '4OLVYr6Q', // Svensk dam reels - mest sett
};
